import React from 'react'
import PropTypes from 'prop-types'
import { parse, format } from 'date-fns'

import { map, join, compact, flatten } from 'lodash'

import { translate, utils, Label } from 'parking-react-common'

import Panel from '../components/Panel'
import Table from '../components/Table'

import { parkingLots } from '../redux'

const WeeklyTimetable = ({ item, t }) => {
    if (!item) {
        return null
    }

    const { schedule } = item
    const hasFixedDurations = parkingLots.hasFixedDurations(item)

    const columns = [
        {
            key    : 'weekday',
            title  : t('Day'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <Label scope="week-timetables.weekday">{ cellData }</Label>
            )
        },
        {
            key   : 'start_time',
            title : t('From'),
            parse : ({ cellData }) => format(parse(cellData, 'HH:mm:ss', new Date()), 'HH:mm')
        },
        {
            key   : 'stop_time',
            title : t('To'),
            parse : ({ cellData }) => format(parse(cellData, 'HH:mm:ss', new Date()), 'HH:mm')
        },
        !hasFixedDurations && {
            key   : 'price',
            title : t('Price')
        }
    ]

    return map(item.opening_intervals, (interval, index) => {
        const title = schedule === parkingLots.SCHEDULE_TYPES.customSchedule
            ? t('Schedule #{{number}}', { number: index + 1 })
            : t('Weekly Schedule')

        return (
            <Panel
                title={ title }
                subtitle={ join(compact(flatten([
                    t('From:'),
                    utils.formatPrettyDate(interval.start_date),
                    !utils.isDistantFutureDate(interval.stop_date) && [
                        t('To:'),
                        utils.formatPrettyDate(interval.stop_date)
                    ]
                ])), ' ') }
                key={ index }
                hasTable
            >
                <Table
                    columns={ columns }
                    data={ interval.week_timetables }
                />
            </Panel>
        )
    })
}

WeeklyTimetable.propTypes = {
    item: PropTypes.object
}

export default translate()(WeeklyTimetable)
